import apiConfig from "@/config/apiConfig";
const rootPath = apiConfig.commonApi;


//企业原始信息模块
export const companyOriginInfo = {
    updateCompanyInfo: rootPath + "/enterpriseCompanyOriginInfo/updateCompanyInfo", // 修改数据(post)
    saveCompanyInfo: rootPath + "/enterpriseCompanyOriginInfo/saveCompanyInfo", // 新增数据(post)
    detailInfo: rootPath + "/enterpriseCompanyOriginInfo/detailInfo", // 详情(get)
    page: rootPath + "/enterpriseCompanyOriginInfo/page", // 详情(get)
    List: rootPath + "/enterpriseCompanyOriginInfo/list", // 不分页数据(get)
    removeCompanyInfo: rootPath + "/enterpriseCompanyOriginInfo/removeCompanyInfo/", // undefined(delete)
    bulkExportExcel: rootPath + "/enterpriseCompanyOriginInfo/bulkExportExcel", // undefined(delete)
    exportExcelTemplate: rootPath + "/enterpriseCompanyOriginInfo/exportExcelTemplate", //下载导入模版
    insertTemplateData: rootPath + "/enterpriseCompanyOriginInfo/insertExcelTemplate", //上传模版数据
};
//客户区域管理
export const area = {
    list: rootPath + "/area/List", // 区域列表
    delete: rootPath + "/area/remove", // 删除 - 批量删除
    saveOrUpdate: rootPath + "/area/saveOrupdate", // 新增或编辑
    detail: rootPath + "/area/detail", // 区域明细接口
    validAreaId: rootPath + "/area/validAreaId", // 区域编码唯一值校验
}

//活动表
export const basicsActivityInfo = {
    detail: rootPath + "/basicsActivityInfo/detail",  //活动详情
}
//活动报名
export const basicsActivityApply = {
    pageList: rootPath + "/basicsActivityApply/pageList",  //分页查询
    detail: rootPath + "/basicsActivityApply/detail",  //报名详情
}

//需求对接
export const basicsNeedInfo = {
    drawNeed: rootPath + "/basicsNeedInfo/drawNeed", // 新增修改(put)
}